<h4 mat-dialog-title>
  <span *ngIf="!user?.id; else editHeader"> Creazione Nuovo Utente </span>
  <ng-template #editHeader>
    Modifica Utente {{ user?.humanIdentifier }}
  </ng-template>
</h4>

<div *ngIf="!loading; else loader">
  <form [formGroup]="form" class="mt-4 row" (keydown.enter)="edit()">
    <mat-form-field>
      <input matInput placeholder="Email" formControlName="email" />
      <mat-icon matSuffix>account_circle</mat-icon>
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        placeholder="Password"
        formControlName="password"
        type="password"
      />
      <mat-icon matSuffix>lock</mat-icon>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="Qualifica" formControlName="qualifica" />
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="Titolo" formControlName="titolo" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Ruoli</mat-label>
      <mat-select multiple placeholder="Ruoli" formControlName="role_ids">
        <mat-option *ngFor="let ruolo of ruoli" [value]="ruolo.id"
          >{{ ruolo.nome }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="Nome" formControlName="nome" />
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="Cognome" formControlName="cognome" />
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        type="number"
        placeholder="Compenso minimo"
        formControlName="compenso_minimo"
      />
      <mat-icon matSuffix>euro</mat-icon>
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        type="number"
        placeholder="Compenso massimo"
        formControlName="compenso_massimo"
      />
      <mat-icon matSuffix>euro</mat-icon>
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        type="number"
        min="0"
        max="100"
        placeholder="Compenso percentuale"
        formControlName="compenso_percentuale"
      />
      <span matSuffix>%</span>
    </mat-form-field>
    <mat-form-field
      matTooltip="Questo compenso viene applicato se l'utente in questione è segnato come 'accertatore' per un incarico. In tal caso, di default, viene tolto l'ammontare dall'emolumento dell'incaricato principale dell'incarico, e viene impostato come emolumento di default dell'accertatore."
    >
      <input
        matInput
        type="number"
        placeholder="Compenso per accertamenti"
        formControlName="compenso_accertamenti"
      />
      <mat-icon matSuffix>euro</mat-icon>
    </mat-form-field>
    <mat-form-field>
      <studio-picker
        placeholder="Studio"
        formControlName="studio"
      ></studio-picker>
    </mat-form-field>
    <mat-form-field>
      <filiale-picker
        placeholder="Filiale"
        formControlName="filiale"
      ></filiale-picker>
    </mat-form-field>
    <mat-form-field>
      <mat-label> Via / piazza </mat-label>
      <input matInput formControlName="via" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> N. civico </mat-label>
      <input matInput formControlName="civico" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Comune </mat-label>
      <comune-picker formControlName="comune"></comune-picker>
    </mat-form-field>
    <mat-form-field>
      <mat-label> Telefono </mat-label>
      <input matInput formControlName="tel" />
    </mat-form-field>
    <mat-form-field>
      <mat-label> Cellulare </mat-label>
      <input matInput formControlName="cell" />
    </mat-form-field>
    <mat-form-field>
      <mat-label> Fax </mat-label>
      <input matInput formControlName="fax" />
    </mat-form-field>

    <!-- Account Collegati -->
    <div class="linked-users-section" *ngIf="user?.id">
      <h4 class="section-title">
        Account Collegati
        <button
          mat-icon-button
          type="button"
          (click)="addLinkedUser()"
          matTooltip="Aggiungi account collegato"
        >
          <mat-icon>person_add</mat-icon>
        </button>
      </h4>
      <mat-chip-list *ngIf="linkedUsers.length > 0">
        <mat-chip *ngFor="let linkedUser of linkedUsers" [removable]="true" (removed)="removeLinkedUser(linkedUser.id)">
          <mat-icon matChipRemove>cancel</mat-icon>
          {{ linkedUser.nome }} {{ linkedUser.cognome }}
          <span *ngIf="linkedUser.studio" class="studio-name">({{ linkedUser.studio.nome }})</span>
        </mat-chip>
      </mat-chip-list>
      <p *ngIf="linkedUsers.length === 0" class="no-linked-users">
        Nessun account collegato
      </p>
    </div>
  </form>
  <button mat-raised-button (click)="edit()" color="primary">Salva</button>
</div>
<ng-template #loader>
  <mat-spinner> </mat-spinner>
</ng-template>
